import YandexGoals from 'www/modules/YandexGoals'

new YandexGoals({
  dataName: 'data-ya-goal',
})
